export default __webpack_public_path__ + "static/media/Sirius_logo.e1ed04f0.png";